module.exports = __webpack_public_path__ + "static/media/use12_eng.69b5fd6a.png";